import { useState, useEffect, useRef, createRef } from 'react'
import { message } from 'antd'
import {
  CloseOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  LeftCircleOutlined,
  RightCircleOutlined
} from '@ant-design/icons'
import generalStore, { toggleVisualFlag, togglePlayFlag, changePlayFlagType } from '@/store/general'
import playStore, { prevSong, nextSong } from '@/store/play'
import { useSnapshot } from 'valtio'
import styles from './css/visual.modules.less'
const Visual = () => {
  const { playObj } = useSnapshot(playStore)
  const { visualFlag, playFlag, playFlagType } = useSnapshot(generalStore)
  const [isInit, setInit] = useState(true)
  const [messageApi, content] = message.useMessage()
  const url = useRef('http://pic.mrzhj.cn/music/letItGo.mp3')
  const audioContextRef = useRef()
  const visualRef = createRef()
  useEffect(() => {
    // console.log(visualFlag)
    if (visualFlag) {
      visualRef.current.classList.add('visual-show')
    } else {
      visualRef.current.classList.remove('visual-show')
    }
  }, [visualFlag])
  useEffect(() => {
    setInit(false)
    if (isInit) {
      initVisual(playObj.url)
      // initVisual(url.current)
      return
    }
    playFlagType == 'footer' && togglePlay()
  }, [playFlag])
  useEffect(() => {
    if (isInit) return
    initVisual(playObj.url)
    // initVisual(url.current)
  }, [playObj.id])

  // 初始化
  const initVisual = val => {
    if (!val) return // 如果没有URL，直接返回
    if (audioContextRef.current) audioContextRef.current.close()
    const canvas = document.querySelector('#canvased')
    if (!canvas) return // 如果canvas不存在，直接返回
    const canvasCtx = canvas.getContext('2d')
    const AudioContext = window.AudioContext || window.webkitAudioContext
    const audioContext = new AudioContext()
    audioContextRef.current = audioContext

    // 创建http请求音频网络资源
    const xhr = new XMLHttpRequest()
    xhr.open('GET', val, true)
    xhr.responseType = 'arraybuffer'
    xhr.onload = function () {
      // 如果请求失败的话使用默认的url资源，一般是403
      if (xhr.status != 200) {
        console.log('启用备用音频')
        initVisual(url.current)
      }
      const audioData = xhr.response // 请求回来的arraybuffer的音频文件
      if (!audioData || audioData.byteLength === 0) {
        console.log('音频数据为空，启用备用音频')
        initVisual(url.current)
        return
      }
      // console.log(audioData)
      //下面就是解码操作 buffer节点
      audioContext.decodeAudioData(audioData, function (buffer) {
        var source = audioContext.createBufferSource()
        var analyser = audioContext.createAnalyser()
        source.buffer = buffer
        analyser.connect(audioContext.destination)
        source.connect(analyser)

        // 设置音量
        const gainNode = audioContext.createGain()
        gainNode.connect(audioContext.destination)
        // 音量取件好像是-1 ———— +1，这就奇怪了
        gainNode.gain.value = -1
        source.connect(gainNode)

        source.start()
        // 初始化不让他播放
        if (isInit) audioContext.suspend()

        var oW = canvas.width
        var oH = canvas.height

        //设置线条的颜色
        var color1 = canvasCtx.createLinearGradient(oW / 2, oH / 2 - 10, oW / 2, oH / 2 - 150)
        color1.addColorStop(0, '#1E90FF')
        color1.addColorStop(0.25, '#FF7F50')
        color1.addColorStop(0.5, '#8A2BE2')
        color1.addColorStop(0.75, '#4169E1')
        color1.addColorStop(1, '#00FFFF')

        var color2 = canvasCtx.createLinearGradient(0, 0, oW, oH)
        color2.addColorStop(0, '#1E90FF')
        color2.addColorStop(0.25, '#FFD700')
        color2.addColorStop(0.5, '#8A2BE2')
        color2.addColorStop(0.75, '#4169E1')
        color2.addColorStop(1, '#FF0000')

        var output = new Uint8Array(180)
        var du = 2 //角度
        var R = 200 //半径
        var W = 2 //宽（线条的粗细）
        ;(function drawSpectrum() {
          analyser.getByteFrequencyData(output)
          canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
          for (var i = 0; i < 360; i++) {
            var value = output[i] / 10
            canvasCtx.beginPath()
            canvasCtx.lineWidth = W
            let Rv1 = R - value
            let Rv2 = R + value
            canvasCtx.moveTo(
              Math.sin(((i * du) / 180) * Math.PI) * Rv1 + oW / 2,
              -Math.cos(((i * du) / 180) * Math.PI) * Rv1 + oH / 2
            )
            canvasCtx.lineTo(
              Math.sin(((i * du) / 180) * Math.PI) * Rv2 + oW / 2,
              -Math.cos(((i * du) / 180) * Math.PI) * Rv2 + oH / 2
            )
            canvasCtx.strokeStyle = color1 //线条的颜色
            canvasCtx.stroke()
          }

          //设置字体样式颜色
          // canvasCtx.font = "20px 华文楷体"
          // canvasCtx.fillStyle = color2 // 设置颜色
          // canvasCtx.textAlign = "center" // 设置水平对齐方式
          // canvasCtx.textBaseline = "middle" // 设置垂直对齐方式
          // // 绘制文字（参数：要写的字，x坐标，y坐标）
          // canvasCtx.fillText(playObj.name, oW / 2, oH / 2)
          requestAnimationFrame(drawSpectrum)
        })()
      })
    }
    xhr.send()
  }
  // 暂停与播放（suspend与resume后面可跟then的回调方法）
  const playChange = val => {
    if (!playObj.id) return
    changePlayFlagType('visual')
    togglePlayFlag(val)
    togglePlay()
  }
  const togglePlay = () => {
    const status = audioContextRef.current.state
    // console.log(status)
    if (status == 'running') audioContextRef.current.suspend()
    else if (status == 'suspended') audioContextRef.current.resume()
  }
  // 上一首与下一首
  const preAndNext = val => {
    if (!playStore.pbList.length) {
      messageApi({
        type: 'warning',
        content: '播放列表为空'
      })
      return
    }
    if (val == 'pre') prevSong()
    else if (val == 'next') nextSong()
  }

  return (
    <div ref={visualRef} className={styles.visualBox}>
      {content}
      {/* {visualFlag && ( */}
      <div className="wrap">
        <CloseOutlined className="close" onClick={toggleVisualFlag} />
        <div className="item">
          <div className="cell">
            <p className="title">{playObj.name}</p>
            <div className="action">
              <LeftCircleOutlined
                className="font1"
                title="上一首"
                onClick={() => preAndNext('pre')}
              />
              {playFlag ? (
                <PauseCircleOutlined
                  className="font2"
                  onClick={() => playChange(false)}
                  title="暂停"
                />
              ) : (
                <PlayCircleOutlined
                  className="font2"
                  onClick={() => playChange(true)}
                  title="播放"
                />
              )}
              <RightCircleOutlined
                className="font1"
                title="下一首"
                onClick={() => preAndNext('next')}
              />
            </div>
            <canvas id="canvased" width="500" height="500"></canvas>
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  )
}
export default Visual
